/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { Modals } from "interfaces/enums";

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    preventBackdrop: false,
    modalName: Modals.NoModal,
    data: {},
  },
  reducers: {
    openModal: (
      state,
      action: {
        payload: { modalName: Modals; data?: any; preventBackdrop?: boolean };
      },
    ) => {
      state.modalName = action.payload.modalName;
      state.data = action.payload.data;
      state.preventBackdrop = !!action.payload.preventBackdrop;
    },
    closeModal: (state) => {
      state.modalName = Modals.NoModal;
      state.data = {};
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export type ModalState = ReturnType<typeof modalSlice.reducer>;
